var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":_vm.googleTranslateLink,"target":"_blank","title":"Translate"}},[_vm._v(" Translate with Google Translate ")])}
var staticRenderFns = []

export { render, staticRenderFns }